import type { MessageModalState } from '../types/passwordReset'

export const CLOSED_MESSAGE_MODAL: MessageModalState = {
  isOpen: false,
  title: '',
  message: '',
}

export const VALIDATION_MESSAGE_TITLE = 'Validation Message'
export const REQUEST_SENT_TITLE = 'Request Sent'

export const PASSWORD_STRENGTH_COLORS = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'] as const
